import React from 'react';
import cx from 'classnames';

import classes from './PageLayout.module.scss';

const PageLayoutDetail = ({ children }) => {
  return <div className={classes.pageDetail}>{children}</div>;
};

const PageLayout = props => {
  const { type, children, detail, className } = props;
  if (type === 'detail') {
    return (
      <div
        className={cx(
          classes.pageLayoutWrapper,
          classes.detailWrapper,
          className
        )}
      >
        <PageLayoutDetail>{detail}</PageLayoutDetail>
        <div className={classes.pageMain}>{children}</div>
      </div>
    );
  }
  return (
    <div className={cx(classes.pageLayoutWrapper, className)}>{children}</div>
  );
};

export { PageLayoutDetail };
export default PageLayout;
